export default "__VITE_ASSET__86b40eda__"